import { FC } from "react";
import { AreaCaseBySubmissionProps } from "../caseVolumeLineChart/types";
import { Link } from "react-router-dom";
import CustomPieChart from "../customPieChart";
import { createSearchParams } from "react-router-dom";
import { globalDoctorTeriitories, practiceTeriitories, territoriesProps } from "src/pages/manufacturer/types";
import { objectToQueryString } from "src/helpers";


const CustomComponentAreaCaseBySubmission: FC<AreaCaseBySubmissionProps> =
  ({ StatisticsObjectType, title, queryParams, isFilterObjUpdated }): JSX.Element => {
    const findPath = () => {
      if (title === "Area Managers") {
        return '/regions'
      } else if (title === "Regional Managers") {
        return '/districts'
      } else if (title === "Reps") {
        return '/territories'
      } else if (title === "Practices") {
        return '/practice_stats'
      } else if (title === "Doctors") {
        return "/doctor_stats"
      }
    }

    return (
      <div className="row flex-fill">
        {title !== "Practices" && title !== "Doctors" ?
          <div className="col-12 col-sm-12 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header">
                <h4 className="m-0 text-center text-primary">{title}</h4>
              </div>

              <div className="card-body p-0 overflow-auto" style={{ maxHeight: '450px' }}>
                <table className="table table-responsive table-hover">
                  <thead className="table-light sticky-top">
                    <tr className="text-center">
                      <th>Name</th>
                      <th>Cases</th>
                    </tr>
                  </thead>
                  <tbody>
                    {StatisticsObjectType.territories && (StatisticsObjectType.territories as territoriesProps).data && (StatisticsObjectType.territories as territoriesProps).data.length > 0 &&
                      (StatisticsObjectType.territories as territoriesProps).data.map((item, key) =>
                        <tr className="text-center" key={key}>
                          <td>
                            <Link
                              to={{
                                pathname: findPath(),
                                search: objectToQueryString({
                                  ...(isFilterObjUpdated() ? queryParams : {}),
                                  id: JSON.stringify(item.id), role: item.role
                                })
                              }}
                              reloadDocument={true}
                              className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                            >
                              {item.name}
                            </Link>
                          </td>
                          <td>{item?.cases}</td>
                        </tr>
                      )
                    }
                  </tbody>
                  <tfoot>
                    <tr className="text-center fw-bold">
                      <td>Total</td>
                      <td>{(StatisticsObjectType.territories as territoriesProps).case_total}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          : null
        }

        {title === "Practices" ?
          <div className="col-12 col-sm-12 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header">
                <h4 className="m-0 text-center text-primary">{title}</h4>
              </div>
              <div className="card-body p-0 overflow-auto" style={{ maxHeight: '450px' }}>
                <table className="table table-responsive table-hover">
                  <thead className="table-light sticky-top">
                    <tr className="text-center">
                      <th>Name</th>
                      <th>Cases</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(StatisticsObjectType?.territories as practiceTeriitories[]) && (StatisticsObjectType?.territories as practiceTeriitories[]).length > 0 &&
                      (StatisticsObjectType?.territories as practiceTeriitories[]).map((item, key) =>
                        <tr className="text-center" key={key}>
                          <td>
                            <Link
                              to={{
                                pathname: findPath(),
                                search: objectToQueryString({
                                  role: 'practice',
                                  id: item.practice_id.toString(),
                                })
                              }}
                              reloadDocument={true}
                              className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                            >
                              {item.practice_name + item.full_address}
                            </Link>
                          </td>
                          <td>{item?.count}</td>
                        </tr>
                      )
                    }
                  </tbody>
                  <tfoot>
                    <tr className="text-center fw-bold">
                      <td>Total</td>
                      <td>
                        {
                          (StatisticsObjectType?.territories as practiceTeriitories[])?.reduce(
                            (acc, curr) => acc + (curr.count || 0),
                            0
                          )
                        }
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          : null
        }

        {title === "Doctors" &&
          <div className="col-12 col-sm-12 col-md-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header">
                <h4 className="m-0 text-center text-primary">{title}</h4>
              </div>
              <div className="card-body p-0 overflow-auto" style={{ maxHeight: '450px' }}>
                <table className="table table-responsive table-hover">
                  <thead className="table-light sticky-top">
                    <tr className="text-center">
                      <th>Name</th>
                      <th>Cases</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(StatisticsObjectType?.territories as globalDoctorTeriitories[]) && (StatisticsObjectType?.territories as globalDoctorTeriitories[]).length > 0 ?
                      (StatisticsObjectType?.territories as globalDoctorTeriitories[]).map((item, key) =>
                        <tr className="text-center" key={key}>
                          <td>
                            <Link
                              to={{
                                pathname: findPath(),
                                search: createSearchParams({
                                  role: "doctor",
                                  id: item.global_doctor_id.toString(),
                                }).toString()
                              }}
                              reloadDocument={true}
                              className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                            >
                              {item.global_doctor_name}
                            </Link>
                          </td>
                          <td>{item?.count}</td>
                        </tr>
                      )
                      : null}
                  </tbody>
                   <tfoot>
                    <tr className="text-center fw-bold">
                      <td>Total</td>
                      <td>
                        {
                          (StatisticsObjectType?.territories as globalDoctorTeriitories[])?.reduce(
                            (acc, curr) => acc + (curr.count || 0),
                            0
                          )
                        }
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        }
        <div className="col-12 col-sm-12 col-md-6 d-flex">
          <CustomPieChart
            title="Cases By Submission Mode"
            pieChartObject={StatisticsObjectType.mos.sort((a, b) => a.name && b.name && (a.name > b.name) ? 1 : -1)}
          />
        </div>
      </div>
    );
  };

export default CustomComponentAreaCaseBySubmission;
